// Third Party Library
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, message } from "antd";

// Constant
import { TEMPLATE } from "../../../../constants";

// Components
import { ButtonLink, DrawerRemark, TableList } from "../../../../components";
import { ActionItems } from "./actions";

// Handler
import { tableHDLR, filter } from "../../../../handlers";
import { DrawerBill } from "../DrawerPayBill";

// Services

import { REDUX as REDUX_UTIL } from "../../../../../v1/services/util";
import { DrawerManageReceipt } from "../DrawerManageReceipt";

const { BILLING_SUMMARY_COL } = TEMPLATE.TABLEDATA.BILLING;
const { BILLING_STATUS_TITLE } = TEMPLATE.BILLING;
const { reduxStoreWrapper } = REDUX_UTIL;

const TableBilling = (props) => {
  const {
    source,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
    selectedRow,
    setSelectedRow,
    selectedRowKeys,
    setSelectedRowKeys,
  } = props;

  const dispatch = useDispatch();

  const [tabStatus, setTabStatus] = useState({});
  const [isOpenBill, setIsOpenBill] = useState(false);
  const [isOpenManageReceipt, setIsOpenManageReceipt] = useState(false);
  const [isOpenRemark, setIsOpenRemark] = useState(false);

  const [data, setData] = useState({});
  const [type, setType] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  
  const loading = useSelector(reduxStoreWrapper("style.loading.billing"));
  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID"));
  const billings = useSelector(reduxStoreWrapper("billing.byID"));
  const billingsCoid = useSelector(reduxStoreWrapper("billing.byCoid"));

  const [originalData, setOriginalData] = useState([]);
  const [isData, setIsData] = useState(false);

  useEffect(() => {
    if (originalData?.length === 0 && !isData && filteredData[tabKey]?.length) {
      setOriginalData(filteredData[tabKey]);
      setIsData(true);
    }
  }, [filteredData, isData, tabKey]);

  const filterData = (data) =>
    filter.filterHDLR.tableData( 
      data,
      filteredInfo,
      sortedInfo,
    );

  useEffect(() => {
    const filteredAndSortedData = filterData(source);

    if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
      setFilteredData(filteredAndSortedData);
    }
  }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);

  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setTabStatus((prev) => ({
      ...prev,
      [tabKey]: true,
    }));
  };

  const handleSearch = (_, confirm) => {
    confirm();
  };

  const columns = [
    ...BILLING_SUMMARY_COL({
      redux: {
        user,
        company,
        billings,
        billingsCoid,
      },
      func: {
        handleSearch,
        DrawerView: (data, type) => {
          setIsOpenBill(true);
          setData(data);
          setType(type);
        },
        DrawerManageReceipt: (data, type) => {
          setIsOpenManageReceipt(true);
          setData(data);
          setType(type);
        },
        DrawerRemark: (data) => {
          setIsOpenRemark(true);
          setData(data);
        },
      },
    }),
    {
      title: "Actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items: ActionItems(
                record,
                setType,
                setIsOpenBill,
                setIsOpenRemark,
                setData,
                user,
                dispatch,
                messageApi
              ),
            }}
          >
            <ButtonLink>Actions</ButtonLink>
          </Dropdown>
        );
      },
    },
  ];

  const onSelectRow = (record, selected) => {
    tableHDLR.selectRow(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      record,
      selected
    );
  };

  const onSelectAllRows = (selected, selectedRows, changeRows) => {
    tableHDLR.selectAllRows(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      changeRows,
      selected
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onSelect: onSelectRow,
    onSelectAll: onSelectAllRows,
  };

  return (
    <>
      {contextHolder}
      <DrawerBill
        isOpen={isOpenBill}
        setIsOpen={setIsOpenBill}
        data={data}
        user={user}
        type={type}
      />
      <DrawerManageReceipt
        isOpen={isOpenManageReceipt}
        setIsOpen={setIsOpenManageReceipt}
        data={data}
        user={user}
        type={type}
      />
      <DrawerRemark
        isOpen={isOpenRemark}
        setIsOpen={setIsOpenRemark}
        refid={data?.billid}
        statusData={BILLING_STATUS_TITLE}
        memid={data?.billid}
      />
      <TableList.DataList
        paginatedData={paginatedData}
        columnData={columns}
        rowSelection={rowSelection}
        onChange={handleTableChange}
        loading={loading}
      />
    </>
  );
};

export default TableBilling;
